import FormControlLabel from "@mui/material/FormControlLabel";
import { useTranslation } from "react-i18next";
import { Checkbox } from "src/components/Default/LekUI/Checkbox";

import Filter from "./DefaultFilters";

interface UnansweredCommentsFilterProps {
	selectedData: Record<string, unknown>;
	setSelectedData: (data: { hasUnansweredComments: boolean }) => void;
	selected: boolean;
	expanded: boolean;
	onChange: () => void;
}

/** Staff: pytania z komentarzem bez odpowiedzi i nierozwiązanym (jak „Bez odpowiedzi” w Admin → Komentarze). */
export function UnansweredCommentsFilter(props: UnansweredCommentsFilterProps) {
	const { t } = useTranslation();
	const checked = !!props.selectedData.hasUnansweredComments;

	return (
		<Filter
			{...props}
			title={t("filters.exams.unansweredComments.title", "Komentarze")}
			renderFilterDetails={() => (
				<FormControlLabel
					label={t("filters.exams.unansweredComments.label", "Bez odpowiedzi")}
					control={
						<Checkbox
							className="checkbox"
							checked={checked}
							onChange={() =>
								props.setSelectedData({ hasUnansweredComments: !checked })
							}
							data-test-id="unanswered-comments-filter"
						/>
					}
				/>
			)}
		/>
	);
}
